export { findNumericSpans, numericVariantLabel, toSuperscript, fromSuperscript, NUMERIC_VARIANTS } from './find-numeric-spans';
export type { NumericVariant } from './find-numeric-spans';
export { buildOrdinalIndex, literalOrdinal, ORDINAL_PREFIX_RE } from './ordinal-index';
export type { OrdinalEntry, OrdinalIndex, OrdinalIndexOptions, OrdinalConflict } from './ordinal-index';
export { resolveNumericSpan, resolveOrdinal } from './resolve-numeric';
